import Product from '@/modules/product/model/Product'
import ProductPagination from '@/modules/product/model/ProductPagination'
import ProductPaginationParams from '@/modules/product/model/ProductPaginationParams'
import {MenuItem} from '@/store/types';

export function routes () {
    return [
        {
            name: 'product.list',
            path: '/tienda/productos',
            component: () => import('@/modules/product/components/ProductList.vue'),
            meta: {
                auth: true,
                toolbarTitle: 'Lista de productos',
                module: 'shop.products',
                vuex: {
                    loadModules: ['product', 'seo'],
                },
            },
        },
        {
            name: 'product.detail',
            path: '/tienda/productos/:id',
            component: () => import('@/modules/product/components/ProductDetail.vue'),
            meta: {
                auth: true,
                toolbarTitle: 'Ver/editar producto',
                module: 'shop.products.product',
            },
        },
    ]
}

export function menu (): MenuItem[] {
    return [
        {
            title: 'Tienda',
            icon: 'mdi-store',
            requireAuthorization: true,
            permission: '@/shop/admin',
            children: [
                {
                    title: 'Pagos online',
                    icon: 'mdi-credit-card',
                    routeName: 'payment.list',
                    requireAuthorization: true,
                    permission: '@/shop/admin/payment',
                },
                {
                    title: 'Productos',
                    icon: 'mdi-basket',
                    routeName: 'product.list',
                    requireAuthorization: true,
                    permission: '@/shop/admin/product',
                },
            ],
        },
    ]
}

export { Product, ProductPagination, ProductPaginationParams }
